let createHistory = require("history").createHashHistory;
export default createHistory();
